import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Legacy `/tips/:id` links (from Facebook shares before Feb 2026) resolve
 * the id to the new slug and hard-navigate to `/guides/{slug}` — closest we
 * can get to a real 301 within a client-side SPA. When id lookup fails we
 * fall back to the guides index so users never hit a 404 from an old share.
 */
const TipRedirect = () => {
  const { id } = useParams();
  const [target, setTarget] = React.useState(null);
  const [failed, setFailed] = React.useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // The public /api/tips list is small enough that a full fetch is
        // acceptable — legacy links are rare and this only runs once per
        // deep-link visit. Prefer a single request over an id-lookup
        // endpoint we haven't built yet.
        const { data } = await axios.get(`${API}/tips`);
        if (cancelled) return;
        const match = Array.isArray(data) ? data.find((t) => t.id === id) : null;
        if (match?.slug) {
          setTarget(`/guides/${match.slug}`);
        } else {
          setFailed(true);
        }
      } catch (err) {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (target) return <Navigate to={target} replace />;
  if (failed) return <Navigate to="/guides" replace />;
  return (
    <div className="max-w-lg mx-auto p-8 text-center text-gray-500" data-testid="tip-redirect-loading">
      Videresender …
    </div>
  );
};

export default TipRedirect;
